import gsap from 'gsap';
import { module } from 'modujs';
import { Pane } from 'tweakpane';

import { lisa, LISA_BASE_PATH } from '../sixty/Lisa';
import { MOBILE_FOV } from '../sixty/MainCamera';

export default class extends module {
    constructor(m) {
        super(m);
    }

    async init() {
        this.viewport = { width: window.innerWidth, height: window.innerHeight };

        await lisa.init(this.el);
        this.onResize();

        this.call('start', null, 'Lisa')

        this.bindEvents();
        this.ticker(0, true);

        // this.showTweakPane();
    }

    bindEvents() {
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('resize', this.onResize);
        this.el.addEventListener('click', this.onClick);
    }

    unbindEvents() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('resize', this.onResize);
        this.el.removeEventListener('click', this.onClick);
    }

    onPointerMove = (e) => {
        lisa.mousemove(e.clientX / this.viewport.width, e.clientY / this.viewport.height);
    }

    onResize = (e) => {
        const BCR = this.el.getBoundingClientRect();
        this.viewport.width = BCR.width;
        this.viewport.height = BCR.height;
        lisa.resize(this.viewport.width, this.viewport.height);

        this.viewOffset = {
            fullWidth: this.viewport.width,
            fullHeight: this.viewport.height,
            x: 0,
            y: 0,
            width: this.viewport.width,
            height: this.viewport.height
        }

        this.setCompact(this.compact, 0);
    }

    onClick = (e) => {
        lisa.click();
    }

    ticker = (dt, reset = false) => {
        lisa.tick(dt, reset);
        this.raf = requestAnimationFrame(this.ticker);
    }

    setCompact(value, duration = 0.3) {
        this.compact = value;
        gsap.killTweensOf(this.viewOffset)
        gsap.killTweensOf(lisa.camera)

        if(this.viewport.width < 1000) {
            gsap.to(this.viewOffset, { y: value ? 0 : this.viewOffset.fullHeight * 0.25, duration, ease: 'Power2.out', onUpdate: () => {
                lisa.camera.setViewOffset(...Object.values(this.viewOffset))
            }})
            gsap.to(lisa.camera, { fov: value ? MOBILE_FOV * 0.75 : MOBILE_FOV, duration, onUpdate: () => {
                lisa.camera.updateProjectionMatrix();
            } })
        } else {
            gsap.to(this.viewOffset, { y: 0, duration, ease: 'Power2.out', onUpdate: () => {
                lisa.camera.setViewOffset(...Object.values(this.viewOffset))
            }})
        }
    }

    showTweakPane() {
        this.pane = new Pane({
            title: 'Parameters',
            expanded: false
        });

        const controlsFolder = this.pane.addFolder({ title: 'Controls', expanded: false });

        controlsFolder.addBinding(lisa, 'screenSwitchedOn', { min: 0, max: 1 });
        controlsFolder.addBinding(lisa, 'screenGlitchIntensity', { min: 0, max: 1 });
        controlsFolder.addBinding(lisa, 'screenGlitchFrequency', { min: 0, max: 10 });
        controlsFolder.addBinding(lisa, 'displayRunningCode', { min: 0, max: 1 });
        controlsFolder.addBinding(lisa, 'speechVolume', { min: 0, max: 1 });
        controlsFolder.addBinding(lisa, 'xDecay', { min: -2, max: 2 });
        controlsFolder.addBinding(lisa, 'darkMode', { min: 0, max: 1 });

        controlsFolder.addButton({
            title: 'Say Yes',
        }).on('click', () => {
            lisa.sayYes();
        });
        controlsFolder.addButton({
            title: 'Say No',
        }).on('click', () => {
            lisa.sayNo();
        });
        controlsFolder.addButton({
            title: 'Hesitate',
        }).on('click', () => {
            lisa.hesitate();
        });

        const screenFolder = this.pane.addFolder({ title: 'Screen content', expanded: false });
        screenFolder
            .addButton({
                title: 'Set left face 1',
            })
            .on('click', () => {
                lisa.setLeftSideContent(LISA_BASE_PATH+'face1.jpg');
            });
        screenFolder
            .addButton({
                title: 'Set right face 1',
            })
            .on('click', () => {
                lisa.setRightSideContent(LISA_BASE_PATH+'face1.jpg');
            });
        screenFolder
            .addButton({
                title: 'Set left face 2',
            })
            .on('click', () => {
                lisa.setLeftSideContent(LISA_BASE_PATH+'face2.jpg');
            });
        screenFolder
            .addButton({
                title: 'Set right face 2',
            })
            .on('click', () => {
                lisa.setRightSideContent(LISA_BASE_PATH+'face2.jpg');
            });
        screenFolder
            .addButton({
                title: 'Set left Video',
            })
            .on('click', () => {
                lisa.setLeftSideContent(LISA_BASE_PATH+'idea.mp4', 'video');
            });
        screenFolder
            .addButton({
                title: 'Set right Video',
            })
            .on('click', () => {
                lisa.setRightSideContent(LISA_BASE_PATH+'idea.mp4', 'video');
            });
        screenFolder
            .addButton({
                title: 'Set vimeo video',
            })
            .on('click', () => {
                const url = 'https://player.vimeo.com/progressive_redirect/playback/953679146/rendition/540p/file.mp4?loc=external&log_user=0&signature=6f6adb99c386852c650bf5842628b0e1c3e01f7bec4e96b95b345295322f3f5d'
                lisa.setLeftSideContent(url, 'video');
                lisa.setRightSideContent(url, 'video');
            });

        // Create a group for camera controls
        const cameraFolder = this.pane.addFolder({ title: 'Camera Controls', expanded: false });

        const viewOffsetFolder = cameraFolder.addFolder({ title: 'View Offset' });

        const updateViewOffset = (e) => {
            lisa.camera.setViewOffset(...Object.values(viewOffset));
        }
        viewOffsetFolder.addBinding(this.viewOffset, 'x', { min: -lisa.viewport.width, max: lisa.viewport.width }).on('change', updateViewOffset)
        viewOffsetFolder.addBinding(this.viewOffset, 'y', { min: -lisa.viewport.height, max: lisa.viewport.height }).on('change', updateViewOffset)
        viewOffsetFolder.addBinding(this.viewOffset, 'width', { min: 0, max: lisa.viewport.width }).on('change', updateViewOffset)
        viewOffsetFolder.addBinding(this.viewOffset, 'height', { min: 0, max: lisa.viewport.height }).on('change', updateViewOffset)

        const frustumFolder = cameraFolder.addFolder({ title: 'Frustum' })
        // Add controls for field of view (fov), near, and far
        frustumFolder.addBinding(lisa.camera, 'fov', { min: 10, max: 120 }).on('change', (e) => {
            lisa.camera.updateProjectionMatrix();
        });

        frustumFolder.addBinding(lisa.camera, 'near', { min: 0.1, max: 10 }).on('change', (e) => {
            lisa.camera.updateProjectionMatrix();
        });

        frustumFolder.addBinding(lisa.camera, 'far', { min: 10, max: 2000 }).on('change', (e) => {
            lisa.camera.updateProjectionMatrix();
        });

        // Add controls for camera position
        const positionFolder = cameraFolder.addFolder({ title: 'Position' });
        positionFolder.addBinding(lisa.camera.position, 'x', { min: -10, max: 10 }).on('change', (e) => {
            lisa.camera.position.x = e.value;
        });
        positionFolder.addBinding(lisa.camera.position, 'y', { min: -10, max: 10 }).on('change', (e) => {
            lisa.camera.position.y = e.value;
        });
        positionFolder.addBinding(lisa.camera.position, 'z', { min: -10, max: 50 }).on('change', (e) => {
            lisa.camera.position.z = e.value;
        });

    }

    destroy() {
        lisa.destroy();
        cancelAnimationFrame(this.raf);
        this.unbindEvents();

        this.pane?.dispose?.();
    }
}
